export default __webpack_public_path__ + "static/location-logo-56ab4c1e6cb298560fdb45aa5738224b.png";